<template>
  <div class="newPatent">

    <div class="tianjia">
      <el-button type="success" @click="insertPatent">{{$t('messages.添加专利')}}</el-button>
    </div>

    <!--编辑 year, patentName, patentOwner, patentNumber, patentCountry -->
    <el-dialog v-model="dialogVisible" :title="$t('messages.专利信息')" @close="dialogClose">
      <el-form ref="formRef" :model="formData" :rules="formRules">
        <el-form-item :label="$t('messages.年份')" prop="year" label-width="80px">
          <el-input v-model="formData.year" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.名字')" prop="patentName" label-width="80px">
          <el-input v-model="formData.patentName" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.发明人')" prop="patentOwner" label-width="80px">
          <el-input v-model="formData.patentOwner" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.专利号')" prop="patentNumber" label-width="80px">
          <el-input v-model="formData.patentNumber" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.国家')" prop="patentCountry" label-width="80px">
          <el-input v-model="formData.patentCountry" autocomplete="off" />
        </el-form-item>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="submitModify">{{$t('messages.确认')}}</el-button>
        <el-button  @click="dialogVisible = false">{{$t('messages.取消')}}</el-button>
      </span>
      </template>
    </el-dialog>

    <el-table :data="tableData" stripe style="width: 100%" border highlight-current-row :header-cell-style="{'text-align':'center'}">
      <el-table-column type="index" :label="$t('messages.序号')" min-width="6" align='center' class="index"/>
      <el-table-column prop="patentName" :label="$t('messages.名字')" min-width="26" align='center'/>
      <el-table-column prop="year" :label="$t('messages.年份')" sortable min-width="9" align='center'/>
      <el-table-column prop="patentOwner" :label="$t('messages.发明人')" min-width="20" align='center' />
      <el-table-column prop="patentNumber" :label="$t('messages.专利号')" min-width="15" align='center'/>
      <el-table-column prop="patentCountry" :label="$t('messages.国家')" min-width="6" align='center'/>
      <el-table-column min-width="10" align='center'>
        <template #header>{{$t('messages.操作')}}</template>
        <template #default="scope">
          <el-button size="small" type="success" @click="handleEdit(scope.$index, scope.row)" style="margin-right: 5px;">Edit</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.$index, scope.row)">Del</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination ref="paging" @pagingChange="pagingChange" :total="count"></pagination>

  </div>

  <Animate ref="animate" />
</template>

<script>
  import {ElMessage, ElMessageBox} from 'element-plus'
  import {ref, reactive, onMounted, getCurrentInstance} from 'vue';
  import { useI18n } from 'vue-i18n'//要在js中使用国际化

  import { queryPatent, totalPatent, modifyPatent, deletePatent, insert } from '@/network/patent'
  import Pagination from "@/components/common/Pagination";
  import Animate from "@/components/common/Animate";

  export default {
    name: "NewPatents",
    components:{
      Pagination,
      Animate,
    },
    setup(){

      let instance = reactive({});
      instance = getCurrentInstance();
      // t 引用i18n
      const { t } = useI18n()
      onMounted(() => {
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })

      // dialogVisible
      let dialogVisible = ref(false);
      // formData
      let formData = reactive({});
      // formRules
      let formRules = reactive({
        patentName: [{ required: true, message: '专利名不能为空', trigger: 'blur' }],
        patentOwner: [{ required: true, message: '专利所有者不能为空', trigger: 'blur' }],
        patentNumber: [{ required: true, message: '专利号不能为空', trigger: 'blur' }],
        patentCountry: [{ required: true, message: '国家信息不能为空', trigger: 'blur' }],
      });
      // flag为真发送修改请求, 为假发送新增专利请求, 默认为真
      let flag = ref(true);



      // pagination配置
      let tableData = reactive([])
      //先调用一下
      queryPatent(0, 20).then(res => {
        if (res.state === 200){
          res.data.forEach(item => tableData.push(item));
        } else if (res.state === '50000'){
          router.push('/regLogin');
          ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
        }
      })

      let count = ref(0);
      totalPatent().then(res => {
        if (res.state === 200){
          //记录总专利数
          count.value = res.data;                                 //用props传参不好用,不知道为啥
          instance.proxy.$refs.paging.pagination.total = res.data;  //这个方案好用
        }
      })

      function pagingChange(pageSize, currentPage) {
        tableData.length = 0;
        if ((currentPage - 1) * pageSize + pageSize > count.value)
          pageSize = count.value - (currentPage - 1) * pageSize;
        queryPatent((currentPage - 1) * pageSize, pageSize).then(res => {
          if (res.state === 200){
            res.data.forEach(item => tableData.push(item));
          } else if (res.state === '50000'){
            router.push('/regLogin');
            ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
          }
        })
      }

      // dialog关闭事件
      function dialogClose() {
        dialogVisible.value = false;
        instance.proxy.$refs.formRef.resetFields();
      }
      // 记录patentId
      let patentId = ref(0);
      // 点击编辑按钮
      function handleEdit(index, row) {
        patentId = tableData[index].id;
        dialogVisible.value = true;
        formData.year = row.year;
        formData.patentName = row.patentName;
        formData.patentOwner = row.patentOwner;
        formData.patentNumber = row.patentNumber;
        formData.patentCountry = row.patentCountry;
      }
      // 发送添加修改请求
      function submitModify(flag) {
        if (flag.value){
          modifyPatent(patentId,formData.year,formData.patentName,formData.patentOwner,formData.patentNumber,formData.patentCountry).then(res => {
            if (res.state === 200)
              if (res.state === 200)
                ElMessage.success(t('messages.修改成功'));
              else if (res.state === '50000'){
                router.push('/regLogin');
                ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
              } else ElMessage.error(t('messages.修改失败'));
          })
        }
        else {
          insert(formData.year,formData.patentName,formData.patentOwner,formData.patentNumber,formData.patentCountry).then(res => {
              if (res.state === 200)
                ElMessage.success(t('messages.添加成功'));
              else if (res.state === '50000'){
                router.push('/regLogin');
                ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
              } else ElMessage.error(t('messages.添加失败'));
          })
          flag.value = true;
        }
        dialogVisible.value = false;
      }
      // 删除
      function handleDelete(index, row) {
        ElMessageBox.confirm(
            t('messages.确认删除?'),
            'Warning',
            {
              confirmButtonText: t('messages.确认'),
              cancelButtonText: t('messages.取消'),
              type: 'warning',
            }
        ).then(() => {
          patentId = tableData[index].id;
          deletePatent(patentId).then(res => {
            if (res.state === 200)
              ElMessage.success(t('messages.删除成功'))
            else if (res.state === '50000'){
              router.push('/regLogin');
              ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
            } else ElMessage.error(t('messages.删除失败'))
          })
        })
      }
      // 添加专利
      function insertPatent() {
        dialogVisible.value = true;
        instance.proxy.$refs.formRef.resetFields();
        flag.value = false;
      }


      return{ tableData, count, dialogVisible, formData, formRules,
        pagingChange, dialogClose, insertPatent, submitModify, handleEdit, handleDelete,
      }
    }
  }
</script>

<style scoped lang="less">

  .tianjia{
    display: flex;
    justify-content: end;
    margin: -32px 20px 30px 0;
  }

  .el-table{
    margin-top: 50px;
  }

  .el-pagination{
    display: flex;
    justify-content: center;
    padding: 40px 20px 100px 0;
  }

</style>